module.exports = __webpack_public_path__ + "img/syscore_logo.14f166c5.svg";